import { Component, Input, OnInit, ViewChild, ChangeDetectionStrategy } from "@angular/core";
import { Reactions, Threads, TimelineItem, TimelineItemType } from "@teammood/timeline";
import { MatTabsModule } from '@angular/material/tabs';
import { ReactionsComponent } from "../../reaction";
import { ThreadsComponent } from "../../../threads/threads.component";
import {
    AgreeDisagreeQuestionResultBarChartComponent
} from "./agree-disagree-poll-result-bar-chart/agree-disagree-question-result-bar-chart.component";
import { TranslateModule, TranslateService } from "@ngx-translate/core";
import { UserInfos } from "../../../../shared/ui/username-icon/user-infos.type";
import { ReviewBadgeComponent } from "../../review-badge/review-badge.component";
import { PollResultService } from "../poll-result.service";
import { PollResultCommentsComponent } from "../poll-result-comments/poll-result-comments.component";
import { AgreeDisagreePollResultTimelineItem } from "../poll-result.type";
import { CommonModule } from "@angular/common";
import { RecurringPollResultTrendsComponent } from "../recurring/recurring-poll-result-trends.component";
import { ManagerPanelComponent } from "../../manager-panel/manager-panel.component";

@Component({
    selector: "tm-agree-disagree-poll-result-card",
    templateUrl: "./agree-disagree-poll-result.component.html",
    styleUrls: ['./../poll-result.scss'],
    standalone: true,
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [
        CommonModule,
        MatTabsModule,
        AgreeDisagreeQuestionResultBarChartComponent,
        ReactionsComponent,
        ThreadsComponent,
        TranslateModule,
        ReviewBadgeComponent,
        PollResultCommentsComponent,
        RecurringPollResultTrendsComponent,
        ManagerPanelComponent
    ]
})
export class AgreeDisagrePollResultCardComponent implements OnInit {
    
    protected showTimelineItemOptions: boolean;
    protected tabIndexToShow: number = 0;
    protected showThreads: boolean = true;
    protected resultsTabLabel: string;
    protected trendsTabLabel: string;
    participationCount: number;

    @ViewChild('threadsComponent')
    private threadsComponent: ThreadsComponent;

    @Input() 
    pollResult: AgreeDisagreePollResultTimelineItem

    @Input() teamId: string;
    
    @Input() userInfos: UserInfos;

    @Input() isOdd: boolean;
    
    constructor(
        private translateService: TranslateService,
        private pollResultService: PollResultService
    ) {
        this.resultsTabLabel = this.translateService.instant('poll_results.results')
        this.trendsTabLabel = this.translateService.instant('poll_results.trends')
    }

    ngOnInit() {
        this.participationCount = this.pollResultService.getParticipationCount(this.pollResult.results.values);
    }

    onTabChanged(event){
        this.tabIndexToShow = event.index;
    }

    protected toggleThreads() {
        this.showThreads = !this.showThreads;
    }
    protected discuss() {
        if (this.threadsComponent) {
            this.threadsComponent.discuss = true;
        }
    }

    protected onReacted(timelineItem: {id: string, itemType: TimelineItemType} & Reactions): void {
        if (timelineItem.itemType == "agreeDisagreeQuestionResultItem"){
            this.pollResult = timelineItem as AgreeDisagreePollResultTimelineItem;
        }
    }

    protected onThreadsUpdated(timelineItem: TimelineItem & Threads): void {
        if (timelineItem.itemType == "agreeDisagreeQuestionResultItem"){
            this.pollResult = timelineItem as AgreeDisagreePollResultTimelineItem;
        }
    }
}